import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiCompass, FiUnlock, FiMap, FiZap} = FiIcons;

const ExplorerPath = () => {
  const benefits = [
    {
      icon: FiUnlock,
      title: 'ความเข้าใจใน "รหัส Bazi" ของคุณ',
      description: 'ค้นพบธาตุแท้,พรสวรรค์ และพลังพิเศษที่จักรวาลมอบให้คุณมาตั้งแต่กำเนิด เพื่อที่คุณจะหยุดเปรียบเทียบและเริ่มต้นสร้างสรรค์ในแบบของตัวเอง'
    },
    {
      icon: FiMap,
      title: '"แผนที่นำทางฉบับส่วนตัว"',
      description: 'ได้รับ Framework จากศาสตร์ ปาจื้อ ที่จะเปลี่ยนความสับสนในการเลือกเส้นทางอาชีพและความสัมพันธ์ ให้กลายเป็นการเดินทางที่ชัดเจนและเปี่ยมด้วยความหมาย'
    },
    {
      icon: FiZap,
      title: 'ปัญญาญาณที่เหนือกว่า',
      description: 'ครอบครองความรู้ของศาสตร์ Bazi ที่น้อยคนจะเข้าถึง เปลี่ยนคุณให้กลายเป็นผู้นำทางความคิดในหมู่เพื่อนฝูง ผู้ที่เข้าใจกลไกของชีวิตในระดับที่ลึกซึ้งกว่า'
    }
  ];

  return (
    <section className="py-20 relative" id="explorer">
      <div className="absolute inset-0 bg-gradient-to-b from-cyan-900/10 via-blue-900/20 to-slate-900"></div>
      
      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          className="text-center mb-16"
          initial={{opacity: 0, y: 30}}
          whileInView={{opacity: 1, y: 0}}
          transition={{duration: 0.8}}
          viewport={{once: true}}
        >
          <div className="flex items-center justify-center mb-8">
            <div className="w-16 h-16 rounded-2xl bg-gradient-to-r from-cyan-500 to-blue-500 flex items-center justify-center mr-4">
              <SafeIcon icon={FiCompass} className="w-8 h-8 text-white" />
            </div>
            <div className="text-left">
              <h2 className="text-4xl md:text-5xl font-light text-white">ค้นพบพิมพ์เขียว Bazi ของคุณ</h2>
            </div>
          </div>
          <div className="bg-gradient-to-r from-cyan-900/30 to-blue-900/30 rounded-2xl p-8 mb-12 border border-cyan-500/20 backdrop-blur-sm">
            <p className="text-2xl text-cyan-100 font-light italic">
              "ตัวตนที่แท้จริงของฉันคือใคร และฉันเกิดมาเพื่อทำอะไร?"
            </p>
          </div>
        </motion.div>

        <motion.div
          className="bg-white/5 backdrop-blur-lg rounded-3xl p-10 border border-white/10 mb-12"
          initial={{opacity: 0, scale: 0.9}}
          whileInView={{opacity: 1, scale: 1}}
          transition={{duration: 0.8}}
          viewport={{once: true}}
        >
          <p className="text-lg text-slate-300 leading-relaxed font-light mb-8">
            คุณคือคนรุ่นใหม่ที่เปิดกว้างและไม่เคยหยุดเรียนรู้ คุณไม่ได้แค่มองหาคำทำนาย... แต่กำลังตามหา <span className="text-cyan-400 font-medium">"คู่มือการใช้งานชีวิต"</span> ที่เป็นของคุณจริงๆ คุณรู้สึกได้ว่ามีพลังบางอย่างซ่อนอยู่ภายใน รอวันที่จะถูกนำออกมาใช้
          </p>
          <p className="text-lg text-slate-300 leading-relaxed font-light">
            ศาสตร์แห่ง <span className="text-blue-400 font-medium">ปาจื้อ (八字,Bazi)</span> คือ <span className="text-cyan-400 font-medium">"กุญแจ"</span> ดอกนั้น ที่จะไขประตูสู่:
          </p>
        </motion.div>

        <div className="space-y-8 mb-12">
          {benefits.map((benefit, index) => (
            <motion.div
              key={index}
              className="bg-gradient-to-r from-white/5 to-white/10 backdrop-blur-lg rounded-2xl p-8 border border-white/10"
              initial={{opacity: 0, x: index % 2 === 0 ? -50 : 50}}
              whileInView={{opacity: 1, x: 0}}
              transition={{duration: 0.8, delay: index * 0.2}}
              viewport={{once: true}}
            >
              <div className="flex items-start space-x-6">
                <div className="w-12 h-12 rounded-xl bg-gradient-to-r from-cyan-500 to-blue-500 flex items-center justify-center flex-shrink-0">
                  <SafeIcon icon={benefit.icon} className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h4 className="text-xl text-white font-light mb-3">{benefit.title}</h4>
                  <p className="text-slate-300 leading-relaxed font-light">{benefit.description}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Testimonial */}
        <motion.div
          className="bg-gradient-to-r from-cyan-900/20 to-blue-900/20 rounded-3xl p-10 border border-cyan-500/20 backdrop-blur-sm text-center"
          initial={{opacity: 0, y: 30}}
          whileInView={{opacity: 1, y: 0}}
          transition={{duration: 0.8, delay: 0.5}}
          viewport={{once: true}}
        >
          <div className="mb-6">
            <div className="w-16 h-16 rounded-full bg-gradient-to-r from-cyan-500 to-blue-500 flex items-center justify-center mx-auto mb-4">
              <span className="text-white font-light text-2xl">M</span>
            </div>
          </div>
          <blockquote className="text-xl text-cyan-100 italic font-light leading-relaxed mb-6">
            "มันไม่ใช่แค่การรู้จักตัวเอง แต่มันคือการ 'จำตัวเองได้' ค่ะ เหมือนได้เจอพิมพ์เขียว Bazi ที่หายไป ตอนนี้ทุกการตัดสินใจมันมาจากความเข้าใจ ไม่ใช่ความกลัวอีกต่อไป"
          </blockquote>
          <cite className="text-cyan-300 font-light">
            — มายา,ศิษย์เก่ารุ่นบุกเบิก
          </cite>
        </motion.div>
      </div>
    </section>
  );
};

export default ExplorerPath;